// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BZdp","colBig":"styles_colBig__2ijTf","colSmall":"styles_colSmall__HWISd"};